import { setSubroute } from 'store/navbar'
import { injectReducer } from 'store/reducers'
import { setPageTitle } from 'utils/misc'
import { UserHasValidPassword, UserIsAuthenticated, UserHasRole } from 'containers/authContainers'
import { USER_ROLES_CAN_ACCESS_DCF_TOOL } from 'utils/constants'
import DataCorrectionV2Container from './containers/DataCorrectionV2Container'
import reducer from './modules/DataCorrectionV2'

export default store => {
  injectReducer(store, {
    key: 'dataCorrectionV2',
    reducer,
  })

  return {
    getComponent(nextState, cb) {
      require.ensure(
        [],
        () => {
          const { params } = nextState
          const { studyID } = params
          const state = store.getState()
          setPageTitle(`Data Correction V2 | Study ${studyID} | ${state.study.currentStudy.platform_name}`)
          store.dispatch(setSubroute('dataCorrectionV2'))

          cb(
            null,
            UserIsAuthenticated(
              UserHasValidPassword(
                UserHasRole(USER_ROLES_CAN_ACCESS_DCF_TOOL, studyID, DataCorrectionV2Container),
              ),
            ),
          )
        },
        'data-correction-v2',
      )
    },
  }
}
